export const ProviderIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g id="Provider" clipPath="url(#clip0_9982_2620)">
        <path
          id="Vector"
          d="M19.1666 19.1668V0.833496H14.4999C13.3953 0.833496 12.4999 1.72893 12.4999 2.8335V9.16683H15.8333L9.99992 15.0002L4.16658 9.16683H7.49992V2.8335C7.49992 1.72893 6.60449 0.833496 5.49992 0.833496H0.833252V19.1668H19.1666Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_9982_2620">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
